import { clientEnv } from "./env.client";

export const getAvatarSrc = (id: string | null | undefined): string | undefined => {
  if (!id) return undefined;
  const baseUrl = clientEnv().NEXT_PUBLIC_API_URL.replace(/\/+$/, "");
  return `${baseUrl}/api/v1/avatars/${encodeURIComponent(id)}`;
};
